import gql from 'graphql-tag';

export const QUERY_GET_PROPERTY_TYPES = gql`
  query LP_ListPropertyTypes {
    listPropertyTypes {
      propertyTypes {
        id
        slug
        name
        description
      }
    }
  }
`;
